import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

interface WaterMarkProps {
    name: string;
    mobile: string;
    isLoggedIn: boolean;
}

interface WaterMarkState {
    row?: number;
    col?: number;
    [stateName: string]: any;
}

class WaterMark extends React.PureComponent<WaterMarkProps, WaterMarkState> {

    state:WaterMarkState = {};

    watcher: number;
    container: HTMLDivElement | null;

    componentDidMount() {
        this.initTimer();
    }

    componentWillUnmount() {
        if (this.watcher) {
            window.cancelAnimationFrame(this.watcher);
        }
    }

    initTimer() {
        if (this.container) {
            let lastScrollHeight: number;
            let lastScrollWidth: number;
            const watch = () => {
                if(this.container) {
                    if (
                        lastScrollHeight !== this.container.scrollHeight ||
                        lastScrollWidth !== this.container.scrollWidth
                    ) {
                        var row = Math.floor(this.container.scrollHeight / 60);
                        var col = Math.floor(this.container.offsetWidth / 100);
                        this.setState({
                            col,
                            row,
                        });
                    }
    
                    lastScrollHeight = this.container.scrollHeight;
                    lastScrollWidth = this.container.scrollWidth;
                }
                
                this.watcher = requestAnimationFrame(watch);
            };
            this.watcher = window.requestAnimationFrame(watch);
        }
    }

    renderContent = () => {
        const {row, col} = this.state;
        const {name, mobile} = this.props;
        let text = '';
        if (name) {
            text += name;
        }
        if(mobile) {
            text += ' ' + mobile.slice(-4);
        }

        const content: any[] = [];
        const width = (100 / (col as number)).toFixed(2) + '%';
        for (let i = 0; i <  (row as number); i++) {
            const arr = [];
            for (let j = 0; j <  (col as number); j++) {
                const style: any = {
                    width,
                };
                const isEvenRow = i % 2 === 0;
                const isEvenCol = j % 2 === 0;
                let childText;
                if (isEvenRow) {
                    childText = isEvenCol ? text : 'ZTO';
                    style.textAlign = isEvenCol ? 'left' : 'center';
                } else {
                    childText = isEvenCol ? 'ZTO' : text;
                    style.textAlign = isEvenCol ? 'center' : 'left';
                }

                arr.push(
                    <p
                        style={style}
                        key={i + '_' + j}
                    >
                        {childText}
                    </p>
                );
            }
            content.push(
                <div className="clearfix">
                    {arr}
                </div>
            )
        }
        return content;
    };

    renderMarks() {
        const {name, mobile} = this.props;
        const {row, col} = this.state;
        let text = '';
        if (name) {
            text += name;
        }
        if(mobile) {
            text += ' ' + mobile.slice(-4);
        }
        if (text && row && col) {
            return this.renderContent();
        }
        return null;
    }

    render() {
        if (!this.props.isLoggedIn) return null;
        return (
            <div
                className="water_mark_container"
                ref={(el) => {
                    this.container = el;
                }}
            >
                {this.renderMarks()}
            </div>
        );
    }
}

function mapStateToProps({session: {ssoUserInfo: userInfo, isLoggedIn }} : {session: { ssoUserInfo?: any, isLoggedIn: boolean }}) {
    return {
        name: userInfo.fullname,
        mobile: userInfo.mobile_phone,
        isLoggedIn,
    };
}

export default connect(mapStateToProps)(WaterMark);


// WEBPACK FOOTER //
// ./src/pages/WaterMark.tsx